
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import countryStateCity from "../countriesStatesCities.json";
import { addAddressInfoAction } from "../../../../../store/actions/PatientsAction";
import Select from "react-select";

const AddressModal = ({ isOpen, onClose, formData, onSubmit, loading }) => {
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);

  const [localFormData, setLocalFormData] = useState({
    tempAddressLine1: "",
    tempAddressLine2: "",
    tempArea: "",
    tempCity: "",
    tempState: "",
    tempCountry: "",
    tempPincode: "",
    permAddressLine1: "",
    permAddressLine2: "",
    permArea: "",
    permCity: "",
    permState: "",
    permCountry: "",
    permPincode: "",
    useSameAddress: false,
  });

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [permStates, setPermStates] = useState([]);
  const [permCities, setPermCities] = useState([]);

  useEffect(() => {
    if (isOpen && formData) {
      setLocalFormData({
        tempAddressLine1: formData.tempAddressLine1 || "",
        tempAddressLine2: formData.tempAddressLine2 || "",
        tempArea: formData.tempArea || "",
        tempCity: formData.tempCity || "",
        tempState: formData.tempState || "",
        tempPincode: formData.tempPincode || "",
        tempCountry: formData.tempCountry || "",
        permAddressLine1: formData.permAddressLine1 || "",
        permAddressLine2: formData.permAddressLine2 || "",
        permArea: formData.permArea || "",
        permCity: formData.permCity || "",
        permState: formData.permState || "",
        permPincode: formData.permPincode || "",
        permCountry: formData.permCountry || "",
        useSameAddress: false,
      });
    }
  }, [isOpen, formData]);

  useEffect(() => {
    const countryList = countryStateCity.map((country) => ({
      value: country.name,
      label: country.name,
    }));
    setCountries(countryList);
  }, []);

  // Load states based on temp country
  useEffect(() => {
    if (localFormData.tempCountry) {
      const selectedCountry = countryStateCity.find(
        (c) => c.name === localFormData.tempCountry
      );
      setStates(
        selectedCountry?.states?.map((state) => ({
          value: state.name,
          label: state.name,
        })) || []
      );
    } else {
      setStates([]);
      setCities([]);
    }
  }, [localFormData.tempCountry]);

  // Load cities based on temp state
  useEffect(() => {
    if (localFormData.tempCountry && localFormData.tempState) {
      const selectedCountry = countryStateCity.find(
        (c) => c.name === localFormData.tempCountry
      );
      const selectedState = selectedCountry?.states?.find(
        (s) => s.name === localFormData.tempState
      );
      setCities(
        selectedState?.cities?.map((city) => ({
          value: city.name,
          label: city.name,
        })) || []
      );
    } else {
      setCities([]);
    }
  }, [localFormData.tempCountry, localFormData.tempState]);

  // Load states based on permanent country
  useEffect(() => {
    if (localFormData.permCountry) {
      const selectedCountry = countryStateCity.find(
        (c) => c.name === localFormData.permCountry
      );
      setPermStates(
        selectedCountry?.states?.map((state) => ({
          value: state.name,
          label: state.name,
        })) || []
      );
    } else {
      setPermStates([]);
      setPermCities([]);
    }
  }, [localFormData.permCountry]);

  // Load cities based on permanent state
  useEffect(() => {
    if (localFormData.permCountry && localFormData.permState) {
      const selectedCountry = countryStateCity.find(
        (c) => c.name === localFormData.permCountry
      );
      const selectedState = selectedCountry?.states?.find(
        (s) => s.name === localFormData.permState
      );
      setPermCities(
        selectedState?.cities?.map((city) => ({
          value: city.name,
          label: city.name,
        })) || []
      );
    } else {
      setPermCities([]);
    }
  }, [localFormData.permCountry, localFormData.permState]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setLocalFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSelectChange = (name, selectedOption) => {
    setLocalFormData((prev) => ({
      ...prev,
      [name]: selectedOption?.value || "",
    }));
  };
  const handleUseSameAddressChange = (e) => {
    const checked = e.target.checked;
    setLocalFormData((prev) => {
      if (checked) {
        return {
          ...prev,
          useSameAddress: true,
          permAddressLine1: prev.tempAddressLine1,
          permAddressLine2: prev.tempAddressLine2,
          permArea: prev.tempArea,
          permCity: prev.tempCity,
          permState: prev.tempState,
          permCountry: prev.tempCountry,
          permPincode: prev.tempPincode,
        };
      } else {
        return {
          ...prev,
          useSameAddress: false,
        };
      }
    });
  };
  useEffect(() => {
    if (localFormData.useSameAddress) {
      setLocalFormData((prev) => ({
        ...prev,
        permAddressLine1: prev.tempAddressLine1,
        permAddressLine2: prev.tempAddressLine2,
        permArea: prev.tempArea,
        permCity: prev.tempCity,
        permState: prev.tempState,
        permCountry: prev.tempCountry,
        permPincode: prev.tempPincode,
      }));
    }
  }, [
    localFormData.useSameAddress,
    localFormData.tempAddressLine1,
    localFormData.tempAddressLine2,
    localFormData.tempArea,
    localFormData.tempCity,
    localFormData.tempState,
    localFormData.tempCountry,
    localFormData.tempPincode,
  ]);
  


  const handleSubmitAddress = async (e) => {
    e.preventDefault();
    if (submitting) return; 
  setSubmitting(true);
    try {
        const patientId = formData.patient_id

      const temporary_address = {
        addressLine1: localFormData.tempAddressLine1 || "",
        addressLine2: localFormData.tempAddressLine2 || "",
        area: localFormData.tempArea || "",
        city: localFormData.tempCity || "",
        state: localFormData.tempState || "",
        country: localFormData.tempCountry || "",
        pincode: localFormData.tempPincode || "",
      };

      const permanent_address = {
        addressLine1: localFormData.permAddressLine1 || "",
        addressLine2: localFormData.permAddressLine2 || "",
        area: localFormData.permArea || "",
        city: localFormData.permCity || "",
        state: localFormData.permState || "",
        country: localFormData.permCountry || "",
        pincode: localFormData.permPincode || "",
        useTemporaryAsPermanent: localFormData.useSameAddress,
      };

      await dispatch(
        addAddressInfoAction({
        patient_id: patientId,
          temporary_address: JSON.stringify(temporary_address),
          permanent_address: JSON.stringify(permanent_address),
        })
      );

  
      if (onSubmit) {
        onSubmit({
          ...formData,
          ...localFormData
        });
      }

      onClose();
    } catch (error) {
      console.error("Error updating address info:", error);
     
    }
    finally {
      setSubmitting(false); 
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal fade show"
      style={{
        display: "block",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1050,
      }}
      onClick={onClose}
    >
      <div className="modal-dialog modal-xl" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Address Details</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>

          <form onSubmit={handleSubmitAddress}>
            <div className="modal-body">
              {/* Temporary Address */}
              <div className="mb-4">
                <h6 className="text-primary mb-3">Temporary Address</h6>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Address Line 1 *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="tempAddressLine1"
                      value={localFormData.tempAddressLine1}
                      onChange={handleChange}
                      placeholder="Enter address line 1"
                      required
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Address Line 2</label>
                    <input
                      type="text"
                      className="form-control"
                      name="tempAddressLine2"
                      value={localFormData.tempAddressLine2}
                      onChange={handleChange}
                      placeholder="Enter address line 2"
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Area *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="tempArea"
                      value={localFormData.tempArea}
                      onChange={handleChange}
                      placeholder="Enter area"
                      required
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Country<span className="text-danger">*</span>
                    </label>
                    <Select
                      options={countries}
                      value={countries.find(c => c.value === localFormData.tempCountry)}
                      onChange={(option) => handleSelectChange("tempCountry", option)}
                      placeholder="Select a Country"
                      styles={selectStyles}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      State<span className="text-danger">*</span>
                    </label>
                    <Select
                      options={states}
                      value={states.find(s => s.value === localFormData.tempState)}
                      onChange={(option) => handleSelectChange("tempState", option)}
                      placeholder="Select a State"
                      styles={selectStyles}
                      isDisabled={!localFormData.tempCountry}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      City<span className="text-danger">*</span>
                    </label>
                    <Select
                      options={cities}
                      value={cities.find(c => c.value === localFormData.tempCity)}
                      onChange={(option) => handleSelectChange("tempCity", option)}
                      placeholder="Select a City"
                      styles={selectStyles}
                      isDisabled={!localFormData.tempState}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Pincode *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="tempPincode"
                      value={localFormData.tempPincode}
                      onChange={handleChange}
                      placeholder="Enter pincode"
                      pattern="[0-9]{6}"
                      maxLength="6"
                      required
                    />
                  </div>
                </div>
              </div>

              {/* Permanent Address */}
              <div className="mb-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="text-primary mb-0">Permanent Address</h6>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="useSameAddress"
                      checked={localFormData.useSameAddress}
                      onChange={handleUseSameAddressChange}
                    />
                    <label className="form-check-label" htmlFor="useSameAddress">
                      Same as temporary address
                    </label>
                  </div>
                </div>
                
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Address Line 1 *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="permAddressLine1"
                      value={localFormData.permAddressLine1}
                      onChange={handleChange}
                      placeholder="Enter address line 1"
                      disabled={localFormData.useSameAddress}
                      required
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Address Line 2</label>
                    <input
                      type="text"
                      className="form-control"
                      name="permAddressLine2"
                      value={localFormData.permAddressLine2}
                      onChange={handleChange}
                      placeholder="Enter address line 2"
                      disabled={localFormData.useSameAddress}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Area *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="permArea"
                      value={localFormData.permArea}
                      onChange={handleChange}
                      placeholder="Enter area"
                      disabled={localFormData.useSameAddress}
                      required
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Country<span className="text-danger">*</span>
                    </label>
                    <Select
                      options={countries}
                      value={countries.find(c => c.value === localFormData.permCountry)}
                      onChange={(option) => handleSelectChange("permCountry", option)}
                      placeholder="Select a Country"
                      styles={selectStyles}
                      isDisabled={localFormData.useSameAddress}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      State<span className="text-danger">*</span>
                    </label>
                    <Select
                      options={permStates}
                      value={permStates.find(s => s.value === localFormData.permState)}
                      onChange={(option) => handleSelectChange("permState", option)}
                      placeholder="Select a State"
                      styles={selectStyles}
                      isDisabled={localFormData.useSameAddress || !localFormData.permCountry}
                    />
                  </div>
                  <div className="col-xl-6 mb-3">
                    <label className="form-label">
                      City<span className="text-danger">*</span>
                    </label>
                    <Select
                      options={permCities}
                      value={permCities.find(c => c.value === localFormData.permCity)}
                      onChange={(option) => handleSelectChange("permCity", option)}
                      
                      placeholder="Select a City"
                      styles={selectStyles}
                      isDisabled={localFormData.useSameAddress || !localFormData.permState}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Pincode *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="permPincode"
                      value={localFormData.permPincode}
                      onChange={handleChange}
                      placeholder="Enter pincode"
                      pattern="[0-9]{6}"
                      maxLength="6"
                      disabled={localFormData.useSameAddress}
                      required
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
         
              {/* <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                    Update...
                  </>
                ) : (
                  "Update "
                )}
              </button> */}
              <button type="submit" className="btn btn-primary" disabled={submitting}>
  {submitting ? (
    <>
      <span
        className="spinner-border spinner-border-sm me-2"
        aria-hidden="true"
      ></span>
      Updating...
    </>
  ) : (
    "Update"
  )}
</button>

            </div>
          </form>
        </div>
      </div>
    </div>
  );
};


const selectStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "50px",
      height: "50px",
    }),
    singleValue: (provided) => ({
      ...provided,
      lineHeight: "50px",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
  };

export default AddressModal;